/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { defaultPrimitive, HTMLContent, ILandingPrimitive, LANDING_TYPE_CONTENT, MarriageItem, VernissageContent } from "src/modules/pe-landing-module/data/interfaces"
import vernissages from "src/modules/pe-landing-module/data/utils/vernissages"
import Floats from "../section/floats/Floats"
import { IPrimitiveProps } from "../section/Primitive"

/* Protopia Ecosystem component */ 
const VernissagePrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: VernissageContent = ( props.primitive || {} ) as VernissageContent
    const vernissage: any = vernissages()[ primitive.design_type || 0 ]
    const positions: any = vernissage.floats
    const text: HTMLContent = primitive.text || {} as HTMLContent
    const coverTitle: HTMLContent = primitive.coverTitle || {} as HTMLContent
    const coverTitle2: HTMLContent = primitive.coverTitle2 || {} as HTMLContent
    const cover: MarriageItem = primitive.cover || {} as MarriageItem
    const [height, ] = useState<string>(getCssDemention( vernissage.height, "700px" ) )

    // console.log( primitive )
    /*
    *   vernissage  - дизайн-матрица
    *   primitive   - данные
    *   floats      - жесткая структура данных
    */

    useEffect(() => {
        addCSSClass(
            `canvas-${primitive.id}`,
            `.canvas-${primitive.id} { 
                height: ${ height };
                z-index:1;
            } `
        ) 
        return () => {
            removeCSSClass(`canvas-${ primitive.id}`)
        } 
    },[])  
    let floats:(ILandingPrimitive | any)[] = []
    floats = [
        ...floats,
        {
            ...defaultPrimitive(),
            id: `${primitive.id}-html`,
            className: "",
            position: {
                top : positions.text.position.top,
                left: positions.text.position.left,
                width: positions.text.position.width,
                height: positions.text.position.height,
                aspect: positions.text.position.width /  positions.text.position.height,
            },
            primitives: [
                {
                    ...defaultPrimitive(),
                    id:`${primitive.id}-1-html`,
                    ...text,
                    type: LANDING_TYPE_CONTENT.HTML,
                    "data-primitive-type": LANDING_TYPE_CONTENT.HTML,
                    className: "p-2", 
                    style: { 
                        "fontSize": 14, 
                        "textAlign": "right",
                        "backgroundColor": "var(--force-plain-secondary-opacity-color)",
                        "padding": 10
                    }, 
                    position: {
                        width:      positions.text.position.width,
                        height:     positions.text.position.height,
                        opacity:    positions.text.position.opacity,
                        rotate:     positions.text.position.rotate,
                        aspect:     positions.text.position.width /  positions.text.position.height,
                    }
                } 
            ]
        },
        {
            ...defaultPrimitive(),
            id: `${primitive.id}-order`,
            className: "",
            position: {
                top : positions.order.position.top,
                left: positions.order.position.left,
                width: positions.order.position.width,
                height: positions.order.position.height,
                aspect: positions.order.position.width /  positions.order.position.height,
            },
            primitives: [
                {
                    ...defaultPrimitive(),
                    id:`${primitive.id}-1-order`,
                    ...{
                        ...primitive.order,
                        data: ( primitive.order|| {} ).data?.map((or: any) => { 
                            return { 
                                ...or, 
                                width:  or.width  || positions.order.position.width, 
                                height: or.height || positions.order.position.height,
                                aspect: (or.width || positions.order.position.width) / (or.height || positions.order.position.height),

                            }
                        })
                    } ,
                    type: LANDING_TYPE_CONTENT.DATA_CONTENT,
                    "data-primitive-type": LANDING_TYPE_CONTENT.DATA_CONTENT,
                    // type: LANDING_TYPE_CONTENT.ORDER,
                    // order: primitive.design_type || 0,
                    // data: { 
                        
                    //     // type: LANDING_TYPE_CONTENT.ICON, 
                    //     // id: getID(LANDING_TYPE_CONTENT.ICON),
                    //     // style: { 
                    //     //     fontSize: 24,
                    //     //     fontWeight: 100,
                    //     //     textAlign: "center",
                    //     // },
                    //     // src: "fas fa-wind" 
                    // },
                    className: "vernissage-order-content", 
                    length: 1,
                    style: { 
                        maxWidth: positions.order.position.width,
                        minHeight: positions.order.position.height,
                        display: "flex",
                        justifyContent:"center",
                        alignItems: "center",
                        border:"1px solid var(--force-contast-color)"
                    },
                    position: {
                        width:      positions.order.position.width,
                        height:     positions.order.position.height,
                        opacity:    positions.order.position.opacity,
                        rotate:     positions.order.position.rotate,
                        aspect:     positions.order.position.width /  positions.order.position.height,

                    }
                } 
            ]
        },
        {
            id: `${primitive.id}-cover`,
            className: "",
            position: {
                top : positions.cover.position.top,
                left: positions.cover.position.left,
                width: positions.cover.position.width,
                height: positions.cover.position.height,
                aspect: positions.cover.position.width /  positions.cover.position.height,
            },
            primitives: [
                {
                    ...defaultPrimitive(),
                    id:`${primitive.id}-cover`,
                    type: LANDING_TYPE_CONTENT.IMAGE,
                    "data-primitive-type": LANDING_TYPE_CONTENT.IMAGE,
                    className: "", 
                    style: { 
                        ...primitive.imageStyle,
                        ...primitive.imageBorder,
                    },
                    hover_size: primitive.hover_size,
                    data: {
                        ...cover,
                        src: primitive.coverImage || cover?.src,
                    },
                    position: {
                        width:      positions.cover.position.width,
                        height:     positions.cover.position.height,
                        opacity:    positions.cover.position.opacity,
                        rotate:     positions.cover.position.rotate,
                        aspect:     positions.cover.position.width /  positions.cover.position.height,

                    }
                },
                {
                    ...defaultPrimitive(),
                    "id": `${primitive.id}-cover-title`,
                    textColor: "#FFFFFF",
                    textSize: 12,
                    ...(coverTitle || {}),
                    type: LANDING_TYPE_CONTENT.HTML,
                    "data-primitive-type": LANDING_TYPE_CONTENT.HTML,
                    "className": "", 
                    "style": { 
                        "backgroundColor": "#9d3017",   
                        "textTransform": "uppercase",
                        "display": "inline-flex",
                        "alignItems": "center",
                        "justifyContent": "center",
                        "marginLeft": "auto",
                        "boxShadow": "0 2px 3px #000000AA"
                    },
                    "position": {
                        top : positions.coverTitle.position.top,
                        left: positions.coverTitle.position.left,
                        width: positions.coverTitle.position.width,
                        height: positions.coverTitle.position.height,
                        aspect: positions.coverTitle.position.width /  positions.coverTitle.position.height,

                    }
                },   
                {
                    ...defaultPrimitive(),
                    "id": `${primitive.id}-title-2`,
                    textColor: "#FFFFFF",

                    ...(coverTitle2 || {}),
                    "type": LANDING_TYPE_CONTENT.HTML,
                    "data-primitive-type": LANDING_TYPE_CONTENT.HTML,
                    "parallax_speed": -0.06,
                    "parallax_y_offset": -80,
                    "effect": "vparallax",
                    "className": "", 
                    "style": { 
                        "display": "flex", 
                        "alignItems": "center",
                        "justifyContent": "center" 
                    },
                    "position": {
                        top : positions.coverTitle2.position.top,
                        left: positions.coverTitle2.position.left,
                        width: positions.coverTitle2.position.width,
                        height: positions.coverTitle2.position.height,
                        aspect: positions.coverTitle2.position.width /  positions.coverTitle2.position.height,

                    } 
                }  
            ]
        },
        ...Array(6).fill(0).map((item, i) => { 
            return {
                id: `${primitive.id}-${i}-item`,
                className: "",
                position: {
                    top : positions["image" + i]?.position.top,
                    left: positions["image" + i]?.position.left,
                    width: positions["image" + i]?.position.width,
                    height: positions["image" + i]?.position.height,
                    aspect: positions["image" + i]?.position.width /  positions["image" + i]?.position.height,
                },
                primitives: [
                    {
                        ...defaultPrimitive(),
                        id:`${primitive.id}-${i}-item`,
                        type: LANDING_TYPE_CONTENT.IMAGE,
                        "data-primitive-type": LANDING_TYPE_CONTENT.IMAGE,
                        className: "", 
                        hover_size: primitive.hover_size,
                        style: { 
                            ...( primitive[ "image" + i ].style   || primitive.imageStyle ),
                            ...( primitive[ "image" + i ].border  || primitive.imageBorder )
                        },
                        data: primitive[ "image" + i ],
                        position: {
                            width:      positions["image" + i]?.position.width,
                            height:     positions["image" + i]?.position.height,
                            opacity:    positions["image" + i]?.position.opacity,
                            rotate:     positions["image" + i]?.position.rotate,
                            aspect:     positions["image" + i]?.position.width /  positions["image" + i]?.position.height,
                        }
                    } 
                ]
            }
        })
    ]
    
    return <div 
        role="article" 
        className={` landing-canvas canvas-${primitive.id}`}
        style={ primitive.data?.style }
    >
        <Floats 
            floats={ floats } 
            animated={primitive.animated} 
            animated_delay={primitive.animated_delay} 
        />
    </div>
}
export default VernissagePrimitive
 